import { NavLink } from "react-router-dom";

import { useUserInfor } from "../../../Context/User/";
import { ACESSOS } from "../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../Validations/UsuarioTela";
import SubNavDropDown from "../SubNavDropDown/SubNavDropDown";
import { SubNavGestaoAtendimentos } from "./subnavs/GestaoAtendimento";
import { SubNavRelAtendimento } from "./subnavs/GestaoRelAtendimentos";

export default function AtendimentoTab() {
    const { UserInfor } = useUserInfor();
    //const [ showDropdown, setshowDropdown ] = useState('');

    return (
        <div className="tab-pane py-5 p-lg-0 active" id="AtendimentoTab">
            <div
                id="kt_header_menu3"
                className="header-menu header-menu-mobile header-menu-root-arrow header-menu-layout-default"
            >
                <ul className="menu-nav">
                    {/* {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.ATENDIMENTO.TELAS.DASHBOARD.ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item"
                                      >
                                          <NavLink
                                              to={
                                                  ACESSOS.ATENDIMENTO.TELAS
                                                      .DASHBOARD.DS_PATH
                                              }
                                              exact
                                              activeClassName="active"
                                              className="menu-link"
                                          >
                                              <span className="menu-text">
                                                  Dashboard
                                              </span>
                                          </NavLink>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null} */}
                    {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.ATENDIMENTO.TELAS.GESTAO_CLIENTES
                                      .ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item"
                                      >
                                          <NavLink
                                              to={
                                                  ACESSOS.ATENDIMENTO.TELAS
                                                      .GESTAO_CLIENTES.DS_PATH
                                              }
                                              exact
                                              activeClassName="active"
                                              className="menu-link"
                                          >
                                              <span className="menu-text">
                                                  Gestão de Clientes
                                              </span>
                                          </NavLink>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null}

                    {/*
                    mostrarDropdownDeTelas( [
                        ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.TODOS.ID_TELA,
                        ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS.USUARIO.ID_TELA,
                        ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.GRUPO.ID_TELA,
                        ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS.ACOMPANHAMENTO.ID_TELA,
                    ], UserInfor.TELAS ) &&
                    <ClickAwayListener mouseEvent="onMouseDown" touchEvent="onTouchEnd" onClickAway={() => {
                        setshowDropdown("");
                    }}>
                        <li className={`menu-item menu-item-submenu ${showDropdown}`}>
                            <span className="menu-link menu-toggle" onClick={() => {
                                if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                                    if(document.getElementsByClassName("menu-item-open menu-item-open-dropdown menu-item-hover").length > 0)
                                        setshowDropdown("");
                                    else   
                                        setshowDropdown("menu-item-open menu-item-open-dropdown menu-item-hover");
                                }else{
                                    if(document.getElementsByClassName("menu-item-rel menu-item-open-dropdown menu-item-hover").length > 0)
                                        setshowDropdown("");
                                    else   
                                        setshowDropdown("menu-item-rel menu-item-open-dropdown menu-item-hover");
                                }
                                
                            }}>
                                <span className="menu-text">Gestão de Atendimentos</span>
                                <span className="menu-desc"></span>
                                <i className="menu-arrow"></i>
                            </span>

                            <GestaoAtendimentoSubnav/>
                        </li>
                    </ClickAwayListener>
                */}

                    <SubNavDropDown
                        title={"Atendimentos"}
                        telas={[
                            ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.TODOS
                                .ID_TELA,
                                ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.GRUPO.ID_TELA,
                                ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS.USUARIO.ID_TELA,
                                ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS.ACOMPANHAMENTO.ID_TELA,

                        ]}
                    >
                        <SubNavGestaoAtendimentos />
                    </SubNavDropDown>
                    {mostrarNavDeTela(
                        ACESSOS.ATENDIMENTO.TELAS.TRIAGEM.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={ACESSOS.ATENDIMENTO.TELAS.TRIAGEM.DS_PATH}
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">Triagem</span>
                            </NavLink>
                        </li>
                    )}
                    <SubNavDropDown
                        title={"Relatórios"}
                        telas={[ACESSOS.ATENDIMENTO.TELAS.CAPYS_BI.ID_TELA]}
                    >
                        <SubNavRelAtendimento />
                    </SubNavDropDown>
                </ul>
            </div>
        </div>
    );
}
